import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
    AnamnesticDataModalComponent,
    CpHttpService,
    EstensaWaitingService,
    ModalDialogNotificationService,
} from '@se/platform';
import { CpReportService } from './cp-report.service';
import { TranslateService } from '@ngx-translate/core';
import { AnamnesticFieldsResponse } from '@se/models';
import { catchError, finalize, map, Observable, of, tap } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AnamnesticDataModalService {
    constructor(
        private dialog: MatDialog,
        private waitingService: EstensaWaitingService,
        private cpHttpService: CpHttpService,
        private reportService: CpReportService,
        private modalDialogNotificationService: ModalDialogNotificationService,
        private translate: TranslateService,
    ) {}

    private getAnamnesticFieldsList(examinationIds: string[]): Observable<AnamnesticFieldsResponse[]> {
        return this.cpHttpService.getAnamnesticFieldsList(examinationIds ?? []);
    }

    onViewAnamnesticData(): Observable<void> {
        this.waitingService.isWaiting = true;

        const examinationsIds: string[] = this.reportService.examinationIds ?? [];

        if (!examinationsIds || examinationsIds.length === 0) {
            this.waitingService.isWaiting = false;
            return of(void 0);
        }

        return this.getAnamnesticFieldsList(examinationsIds).pipe(
            catchError((error) => {
                console.error('Errore durante il recupero dei dati anamnestici', error);
                this.modalDialogNotificationService.error(this.translate.instant('GenericError'));
                return of([]);
            }),
            tap((responseList) => {
                const isEmpty = responseList.every((el) => el.anamnesticFields.length === 0);

                if (isEmpty) {
                    this.modalDialogNotificationService.info(this.translate.instant('NotAvailableData'));
                } else {
                    this.dialog.open<AnamnesticDataModalComponent>(AnamnesticDataModalComponent, {
                        width: '80%',
                        data: responseList,
                        panelClass: 'custom-dialog-container',
                    });
                }
            }),
            finalize(() => (this.waitingService.isWaiting = false)),
            map(() => void 0),
        );
    }
}
